import http from './http';
import apiEnum from './apiEnum';

// 直播间猫列表
export interface ReqCatList {
  businessId: string; /** 猫屋id */
  businessType: number; /** 1-猫屋 2-品牌 */
  curPage?: string; /** 注释 */
  pageSize?: number; /** 注释 */
  lastId?: string; /** 最后一条Id */
}

export interface AssistanceList {
  type: number; /** 1-品牌/个人 2-普通用户 */
  background?: string; /** 背景 */
  image?: string; /** 头像/logo */
  userId?: string
  content?: string; /** 文案 */
}
export interface SterilizationProgressInfo {
  mainText?: string; /** 主文案 */
  subText?: string; /** 副文案 */
  progress?: number; /** 进度 */
  buttonText?: string; /** 按钮文案 */
  background?: string; /** 背景 */
  crowdFundOrderId?: string; /** 标记id */
  assistanceList?: AssistanceList[]; /** 赞助列表 */
}

export interface CatRecords {
  id?: string; /** id */
  assistStatus?: number; /** 赞助状态 */
  avatar?: string; /** 头像 */
  name?: string; /** 名称 */
  date?: string; /** 日期 */
  variety?: string; /** 品种 */
  sex?: string; /** 性别 */
  sterilizationState?: string; /** 绝育状态 */
  varietyText?: string; /** 品种 */
  sexText?: string; /** 性别 */
  sterilizationStateText?: string; /** 绝育状态 */
  recommendContentList?: string[]; /** 推荐内容 */
  background?: string; /** 背景 */
  sterilizationProgressInfo?: SterilizationProgressInfo; /** 绝育进度 */
}

export interface Page {
  curPage?: string; /** 注释 */
  pageSize?: string; /** 注释 */
  pages?: string; /** 注释 */
  total?: string; /** 注释 */
}

export interface ResCatList {
  page?: Page; /** 注释 */
  records?: CatRecords[]; /** 注释 */
}

/**
 * 直播间猫列表Api
 * @param data
 * @returns
 */

export const requestCatListApi = (data: ReqCatList): Promise<{
  code: number;
  data: ResCatList;
  msg: string
}> =>
  http.post({
    action: apiEnum.catListAction,
    data,
  });
